import React from 'react';

import Typography from '@material-ui/core/Typography';

export function ProfileSection() {
  return <Typography paragraph>This is the profile section</Typography>;
}
